"use strict";
/**
 * @reducer modal.reducer - returns the state of the modal
 */
Object.defineProperty(exports, "__esModule", { value: true });
var modal_view_selection_1 = require("../modal-view-selection");
/**
 * @function modalStateReducer
 * @param state
 * @param action
 * @returns string - 'open' | 'closed' | 'animate-open' | 'animate-closed'
 */
function modalStateReducer(state, action) {
    if (state === void 0) { state = ''; }
    if (action.route) {
        var nextState = modal_view_selection_1.getModalState(action.route);
        if (state !== nextState) {
            return nextState;
        }
        return state;
    }
    return state;
}
exports.default = modalStateReducer;
